import React from 'react';
import LegalLayout from '../components/LegalLayout';

const phoneNumber = String.fromCharCode(
  43, 52, 57, 32, 49, 55, 54, 32, 57, 49, 51, 57, 55, 50, 50, 56
);
const phoneLink = String.fromCharCode(
  116, 101, 108, 58, 43, 52, 57, 49, 55, 54, 57, 49, 51, 57, 55, 50, 50, 56
);
const emailAddress = String.fromCharCode(
  115, 105, 100, 101, 64, 101, 99, 111, 109, 99, 111, 100, 101, 108, 97, 98, 46, 100, 101
);

const Impressum = () => {
  return (
    <LegalLayout title="Impressum">
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-bold text-textMain mb-2">Angaben gemäß § 5 TMG</h2>
          <p className="text-textMuted leading-relaxed">
            ecomcodelab<br />
            Billy Kittler<br />
            Demminer Str 17<br />
            13059 Berlin<br />
            Deutschland
          </p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-textMain mb-2">Kontakt</h2>
          <p className="text-textMuted leading-relaxed">
            Telefon: <a href={phoneLink}>{phoneNumber}</a><br />
            E-Mail: <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
          </p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-textMain mb-2">Umsatzsteuer-ID</h2>
          <p className="text-textMuted leading-relaxed">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            DE300243325
          </p>
        </div>

        <div className="pt-6 border-t border-borderDark">
          <p className="text-xs text-textMuted italic">
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: Billy Kittler, Demminer Str 17, 13059 Berlin
          </p>
        </div>
      </div>
    </LegalLayout>
  );
};

export default Impressum;